const BreadcrumbText = {
    viewStatus: {
        english: 'View status',
        spanish: 'Ver estado'
    },
    accommodationDetails: {
        english: 'Accommodation details',
        spanish: 'Detalles del alojamiento'
    },
    claimDetails: {
        english: 'Claim details',
        spanish: 'Detalles del reclamo'
    },
    leaveDetails: {
        english: 'Leave details',
        spanish: 'Dejar detalles'
    }
};
export default BreadcrumbText;
